import React from "react";

import OfferListItem from "./OfferListItem";
import NoResults from "../../../common/NoResults";
import { SonicOfferData } from "../../../common/classes/SonicOffer";
import Modal from "../../../common/management/Modal";

import { CategoryState } from "../../../utils/CategoryState";

import styles from "../../management/db-list/DBList.module.scss";
import { SonicOfferMetaData } from "../../../common/classes/SonicOfferMeta";

type Props = {
  offers: Array<SonicOfferData>;
  meta: Array<SonicOfferMetaData>;
  showModal: boolean;
  handleModal: () => void;
  modalProps: string;
  handleModalProps: (value: string) => void;
  isSelect: boolean;
};

const OfferList: React.FC<Props> = ({
  offers,
  meta,
  showModal,
  handleModal,
  modalProps,
  handleModalProps,
  isSelect,
}) => {
  if (offers.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["offer"]}`}
      >
        <div className={styles["column"]}>
          <div>オファー対象者</div>
          <span>名前</span>
        </div>
        <div>プロフィール名</div>
        <div className={styles["column"]}>
          <div>オファー元</div>
          <span>{isSelect ? "会員名" : "学生名"}</span>
        </div>
        <div>申請日時</div>
        <div>ステータス</div>
        <div>アクション</div>
      </div>
      {offers.map((offer, i) => (
        <OfferListItem
          key={i}
          id={offer.id}
          status={offer.status}
          timestamp={offer.timestamp}
          memo={offer.memo}
          fromName={
            !isSelect && meta?.[i].from.full_name
              ? (meta?.[i].from.full_name as string)
              : meta?.[i].from.name
          }
          to={meta?.[i].to}
          recipientName={
            !isSelect && meta?.[i].recipient.full_name
              ? (meta?.[i].recipient.full_name as string)
              : meta?.[i].recipient.name
          }
          handleModal={handleModal}
          handleModalProps={handleModalProps}
          isSelect={isSelect}
        />
      ))}
      {showModal === true ? (
        <Modal
          closeModal={handleModal}
          categoryState={CategoryState.Memo}
          headText="メモを確認"
        >
          {modalProps}
        </Modal>
      ) : null}
    </div>
  );
};

export default OfferList;
